'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00249 from "./presto.-Agent-View$$anon$9.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dClosed$0024 from "./presto.-Agent-View$-Closed$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$8() {
  this.aAS = null;
  this.aAK = null;
  this.aAL = false;
  this.aAT = null;
  this.aAU = false;
  this.aAX = null;
  this.aAQ = null;
  this.aAR = false;
  this.aAM = null;
  this.aAN = false;
  this.aAO = null;
  this.aAP = false;
  this.aAV = false;
  this.aAW = false;
  this.aAS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aAX = "Closed";
}
export { $c_Lpresto_AgentView$$anon$8 as $c_Lpresto_AgentView$$anon$8 };
$p = $c_Lpresto_AgentView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$8;
/** @constructor */
function $h_Lpresto_AgentView$$anon$8() {
}
export { $h_Lpresto_AgentView$$anon$8 as $h_Lpresto_AgentView$$anon$8 };
$h_Lpresto_AgentView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aAS;
});
$p.M = (function() {
  if ((!this.aAL)) {
    this.aAK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aAL = true;
  }
  return this.aAK;
});
$p.O = (function() {
  if ((!this.aAU)) {
    this.aAT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aAU = true;
  }
  return this.aAT;
});
$p.D = (function() {
  return this.aAX;
});
$p.t = (function() {
  if ((!this.aAR)) {
    this.aAQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aAR = true;
  }
  return this.aAQ;
});
$p.N = (function() {
  if ((!this.aAN)) {
    this.aAM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aAN = true;
  }
  return this.aAM;
});
$p.Q = (function() {
  if ((!this.aAP)) {
    this.aAO = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00249.$c_Lpresto_AgentView$$anon$9();
    this.aAP = true;
  }
  return this.aAO;
});
$p.v = (function() {
  if ((!this.aAW)) {
    this.aAV = false;
    this.aAW = true;
  }
  return this.aAV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee64) => ((p) => \u03b4scrutinee64))($j_presto$002e$002dAgent$002dView$0024$002dClosed$0024.$m_Lpresto_AgentView$Closed$())));
});
var $d_Lpresto_AgentView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$8, "presto.AgentView$$anon$8", ({
  Ei: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$8 as $d_Lpresto_AgentView$$anon$8 };
//# sourceMappingURL=presto.-Agent-View$$anon$8.js.map
